import { NgModule } from '@angular/core';
import { PaperlessCommercialInvoiceService } from './services/paperless-commercial-invoice.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../../shared.module';
import { PaperlessCommercialInvoiceTermsDialogComponent } from './components/paperless-commercial-invoice-terms-dialog/paperless-commercial-invoice-terms-dialog.component';
import { PaperlessCommercialInvoiceSettingsDialogComponent } from './components/paperless-commercial-invoice-settings-dialog/paperless-commercial-invoice-settings-dialog.component';

@NgModule({
    imports: [
        FormsModule,
        ReactiveFormsModule,
        SharedModule,
    ],
    declarations: [
        PaperlessCommercialInvoiceTermsDialogComponent,
        PaperlessCommercialInvoiceSettingsDialogComponent,
    ],
    providers: [
        PaperlessCommercialInvoiceService,
    ],
    exports: [
        PaperlessCommercialInvoiceTermsDialogComponent,
        PaperlessCommercialInvoiceSettingsDialogComponent,
    ]
})
export class PaperlessCommercialInvoiceModule {}
